import { useOkapiKy } from '@folio/stripes/core';
import { useQuery } from 'react-query';
var SYSTEM_USER_IDS = {
    '00000000-0000-0000-0000-000000000000': 'System',
    '00000000-0000-0000-0000-000000000001': 'Import',
};
/**
 * Resolves a user UUID to a display name (firstName lastName).
 * Returns a label for known system UUIDs, UUID as fallback for unknown users.
 *
 * <p>Reads `czna-users/users/{id}/name`, not `czna-users/users/{id}` (CZNA-776).
 * The full user record is gated on `czna-users.users.item.get`, which an ordinary
 * cataloguer does not hold — measured on the local tenant 2026-08-28, that call
 * answered 403 for the cataloguer persona and every attribution on screen degraded
 * to the raw UUID. The name-only endpoint is held by every user instead, so nobody
 * has to be handed a colleague's e-mail, phone and roles to see who wrote a proposal.
 *
 * <p>`sigla` (CZNA-1616) is the sigla of the user's current organization, or null. It is
 * returned beside `name`, never folded into it: only the record detail shows it, and every
 * other caller renders `name` exactly as before.
 */
var useUserName = function (id) {
    var _a;
    var ky = useOkapiKy();
    var systemLabel = id ? SYSTEM_USER_IDS[id] : undefined;
    var _b = useQuery(['userName', id], function () { return ky.get("czna-users/users/".concat(id, "/name")).json(); }, {
        enabled: !!id && !systemLabel,
        staleTime: 5 * 60 * 1000,
        retry: false,
    }), data = _b.data, isLoading = _b.isLoading;
    if (!id)
        return { name: null, sigla: null, isLoading: false };
    if (systemLabel)
        return { name: systemLabel, sigla: null, isLoading: false };
    var name = data ? "".concat(data.firstName, " ").concat(data.lastName) : id;
    var sigla = (_a = data === null || data === void 0 ? void 0 : data.organizationSigla) !== null && _a !== void 0 ? _a : null;
    return { name: name, sigla: sigla, isLoading: isLoading };
};
export default useUserName;
